import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useOnlineUntil = (nextRenewal: string | null) => {
  const { t, i18n } = useTranslation('common', { keyPrefix: 'jobStatus' });

  const onlineUntil = useMemo(() => {
    if (!nextRenewal) {
      return null;
    }
    const onlineUntil = new Date(nextRenewal);
    onlineUntil.setDate(onlineUntil.getDate() - 1);
    return onlineUntil;
  }, [nextRenewal]);

  const formattedOnlineUntil = useMemo(
    () =>
      onlineUntil
        ? onlineUntil.toLocaleDateString(i18n.language, { dateStyle: 'medium' })
        : t('unknown'),
    [i18n.language, onlineUntil, t],
  );

  return { formattedOnlineUntil, onlineUntil };
};
